import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useLang } from "../../context/LangContext";
import { IMAGES } from "../../lib/i18n";

const Panel = ({ item, img, idx, cursor }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const scale = useTransform(scrollYProgress, [0, 0.5, 1], [1.25, 1, 1.12]);
  const imgY = useTransform(scrollYProgress, [0, 1], ["-6%", "6%"]);
  const titleY = useTransform(scrollYProgress, [0.1, 0.45], ["60%", "0%"]);
  const titleO = useTransform(scrollYProgress, [0.1, 0.4], [0, 1]);
  const listO = useTransform(scrollYProgress, [0.3, 0.55], [0, 1]);
  const listY = useTransform(scrollYProgress, [0.3, 0.55], [40, 0]);
  const veil = useTransform(scrollYProgress, [0, 0.5, 1], [0.8, 0.5, 0.85]);
  const [first, ...rest] = item.name.split(" ");

  return (
    <div ref={ref} className="relative h-[140vh]" data-testid={`sector-card-${idx}`} data-cursor={cursor}>
      <div className="sticky top-0 h-screen overflow-hidden">
        <motion.img src={img} alt={item.name} style={{ scale, y: imgY }} className="absolute inset-0 h-full w-full object-cover" />
        <motion.div className="absolute inset-0 bg-[#0a0a0b]" style={{ opacity: veil }} />
        <div className="pointer-events-none absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-[#0a0a0b] to-transparent" />
        <div className="wrap relative flex h-full flex-col justify-end pb-16 md:pb-24">
          <span className="mb-6 w-fit rounded-full border border-white/20 px-3 py-1 font-mono text-[10px] uppercase tracking-[0.3em] text-white/70 backdrop-blur-md">
            {String(idx + 1).padStart(2, "0")} · {item.tag}
          </span>
          <div className="overflow-hidden">
            <motion.h3 style={{ y: titleY, opacity: titleO }} className="font-display text-[3.4rem] font-bold leading-[0.95] tracking-[-0.03em] text-[#fafaf7] sm:text-7xl lg:text-[8.5rem]">
              {first} <span className="font-serif-i gold-text font-normal">{rest.join(" ")}</span>
            </motion.h3>
          </div>
          <motion.ul style={{ opacity: listO, y: listY }} className="mt-10 grid gap-4 md:grid-cols-3 md:gap-8">
            {item.bullets.map((b, i) => (
              <li key={b} className="border-t border-white/20 pt-4 text-sm text-white/90 md:text-base">
                <span className="mb-3 block font-mono text-[10px] tracking-[0.3em] text-[#e8c979]">0{i + 1}</span>{b}
              </li>
            ))}
          </motion.ul>
        </div>
      </div>
    </div>
  );
};

export const Sectors = () => {
  const { t } = useLang();
  const s = t.sectors;
  return (
    <section id="settori" data-testid="sectors-section" className="relative bg-[#0a0a0b] text-[#fafaf7]">
      <div className="wrap flex items-end justify-between pb-10 pt-24 md:pt-32">
        <p className="eyebrow">{s.eyebrow}</p>
        <h2 className="max-w-xl text-right font-display text-xl font-medium tracking-tight text-white/70 md:text-2xl">{s.title}</h2>
      </div>
      <Panel item={s.items[0]} img={IMAGES.satellite} idx={0} cursor={t.cursor.sector} />
      <Panel item={s.items[1]} img={IMAGES.evtol} idx={1} cursor={t.cursor.sector} />
    </section>
  );
};
